import { Component } from '@angular/core';
import { RetailersService } from '../retailers/retailers.service';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  Role:any=0
  Id:any=0
  
  constructor(public service:RetailersService,public loginService:LoginService) {
    this.Role=localStorage.getItem("RoleType")
    console.log(localStorage.getItem("Token"))
    console.log(this.Role)
    if(this.Role==4){
      this.Id=localStorage.getItem("RetailerId")
      this.getRetailer()
    }
  }
  getRetailer(){
    this.service.GetRetailerById(this.Id).subscribe((res:any)=>{
      console.log(res)
    })
  }
  logout() {
    this.loginService.logout();
  }
}
